// Share in-flight requests between the configurator and mileage chart.
// Each consumer owns its result cache; completed requests leave this registry.
const requests = new Map();

export function regionalPrices(url) {
  if (!requests.has(url)) {
    const request = fetch(url, { headers: { Accept: 'application/json' } })
      .then(async response => {
        if (!response.ok) throw new Error('State prices unavailable');
        const data = await response.json();
        if (!['ready', 'empty'].includes(data.status)) throw new Error('State prices unavailable');
        return data;
      }).finally(() => requests.delete(url));
    requests.set(url, request);
  }
  return requests.get(url);
}

export function historicalPeriod(data) {
  return `No qualifying active listings right now. Prices are from vehicles listed during the last 3 months (${data.period_start}–${data.period_end}), using the latest recorded asking price per VIN.`;
}
